// @flow

import { API_ENDPOINT } from 'shared/config';

export const MFAMigrated = (email: string): Promise<boolean> =>
  fetch(`${API_ENDPOINT}/users/mfa_migrated`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email
    })
  }).then((res) => {
    if (res.ok) {
      return res.json().then(({ mfa_migrated }) => mfa_migrated);
    }

    return false;
  });

export default MFAMigrated;
